import CryptoJS from "crypto-js";

/**
 * Decrypts a base64-encoded AES-128-CBC token using the provided key.
 * @param {string} token - The encrypted token (base64 encoded)
 * @param {string} keyString - The AES key (must be 16 bytes for AES-128)
 * @param {Buffer|string} [iv] - The initialization vector (16 bytes). Defaults to zero IV.
 * @returns {string} The decrypted token
 */
export function decryptToken(token, keyString = "LoadshareAESKey1") {
  if (keyString.length !== 16) {
    throw new Error("Encryption key must be exactly 16 characters for AES-128");
  }

  // Convert base64url to base64
  const base64 = token.replace(/-/g, "+").replace(/_/g, "/");
  // Pad base64 string if necessary
  const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, "=");

  const encrypted = CryptoJS.enc.Base64.parse(padded);
  const key = CryptoJS.enc.Utf8.parse(keyString);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encrypted },
    key,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.NoPadding,
    }
  );
  return CryptoJS.enc.Utf8.stringify(decrypted).replace(/\0+$/, '').trim();
}

/**
 * Generates a SHA-256 checksum from tokenId and organisationCode
 * @param {string} tokenId
 * @param {string} organisationCode
 * @returns {string} SHA-256 checksum (hex)
 */
export function generateChecksum(tokenId, organisationCode) {
  const data = `${tokenId}|${organisationCode}`;
  return CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex);
}
